import { useState } from "react";

import { Button, ErrorUI, SVGSprite } from "@/components/Atoms";
import PaymentModal from "../PaymentModal";
import WaitListModal from "../WaitListModal";

import styles from "./ClassListPurchaseFlow.module.scss";

const ClassListPurchaseFlow: React.FC<any> = (props) => {
  const {
    classDetail,
    price,
    isEventEnded,
    eventEndedMessage,
    allSlotsBookedMessage,
    isWaitListEnabled,
    isWaitListJoined,
    monthlyPrice,
  } = props;

  const [openPaymentModal, setOpenPaymentModal] = useState(false);
  const [openWaitListModal, setOpenWaitListModal] = useState(false);

  const arrowRight = (
    <SVGSprite
      className="icon"
      icon="icon-arrow-right-book-slot"
      height="24px"
      width="24px"
      style={{ marginLeft: "4px" }}
    />
  );

  const arrowIcon = (
    <SVGSprite
      className="icon"
      icon="icon-arrow-right-book-slot"
      height="24px"
      width="24px"
    />
  );

  const successIcon = (
    <SVGSprite
      className="icon"
      icon="icon-arrow-right-success"
      height="24px"
      width="24px"
      fill="#fff"
    />
  );

  let button;
  if (isEventEnded) {
    button = (
      <Button variant={"primary1"} className="all-slots-booked" disabled>
        {eventEndedMessage || "Can't book now. This event has ended!"}
      </Button>
    );
  } else if (classDetail?.hasAllSlotsBooked) {
    if (isWaitListEnabled) {
      button = (
        <div className="wait-list-wrapper">
          <ErrorUI
            error={allSlotsBookedMessage || "All slots are booked!"}
            isNotAbsolute
            iconDimension="18px"
            fontSize="14px"
            lineHeight="24px"
          />
          {isWaitListJoined ? (
            <Button
              className={styles.single}
              variant={"primary1"}
              TextColor="#32D583"
            >
              Added to waitlist
              {successIcon}
            </Button>
          ) : (
            <Button
              className={styles.single}
              variant={"primary1"}
              onClick={() => setOpenWaitListModal(props)}
            >
              Join the waitlist
              {arrowIcon}
            </Button>
          )}
        </div>
      );
    } else {
      button = (
        <Button variant={"primary1"} className="all-slots-booked" disabled>
          All slots are booked
        </Button>
      );
    }
  } else {
    button = (
      <Button
        className={styles.single}
        variant="primary1"
        onClick={() => setOpenPaymentModal(props)}
        id="single-class-purchase-button"
      >
        Book a slot for this workout for {price}
        {arrowRight}
      </Button>
    );
  }

  return (
    <div className={styles.actionButtons}>
      {button}
      {/* <Button
        className={styles.monthly}
        variant="primary1"
        onClick={() => {
          window.location.href = "/shyftpass#buynow";
        }}
        id="shyftpass-purchase-button"
      >
        Buy Shyft Pass for {monthlyPrice} for a month
        {arrowRight}
      </Button> */}
      {openPaymentModal && (
        <PaymentModal
          openPaymentModal={openPaymentModal}
          setOpenPaymentModal={setOpenPaymentModal}
        />
      )}
      {openWaitListModal && (
        <WaitListModal
          openWaitListModal={openWaitListModal}
          setOpenWaitListModal={setOpenWaitListModal}
        />
      )}
    </div>
  );
};

export default ClassListPurchaseFlow;
